import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./agrorad/agrorad.module').then(m => m.AgroradModule),
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'agrorad'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
